import qs from 'query-string';
import { getAppConfig } from '@/api/app';
import { setStorage, getStorage } from '@/base/store/storage';
import { setToken } from '@/base/store/auth';
import { getCookie } from '@/base/store/cookie';

export async function initApp () {
  const query = qs.parse(window.location.search);

  const { path_k, mobile, ext_s, campaign_id = '', adset_id = '', ad_id = '' } = query;

  if (path_k) setStorage('path_k', path_k);

  if (mobile) setStorage('mobile', mobile);

  if (ext_s) {
    const externalParams = {
      external_sources: ext_s,
      fbc: getCookie('_fbc') || '',
      fbp: getCookie('_fbp') || '',
      project_id: campaign_id,
      adset_id,
      promotion_id: ad_id,
    };

    setStorage('external_params', JSON.stringify(externalParams));
  }

  const sourcePromotionId = query.source_promotion_id;
  const localPromotionId = getStorage('promotion_id');

  if (sourcePromotionId) {
    if (localPromotionId && sourcePromotionId !== localPromotionId) {
      setToken('');
    }
    setStorage('promotion_id', sourcePromotionId);
  } else if (!localPromotionId) {
    try {
      const data = await getAppConfig();
      if (data?.default_promotion_id) {
        setStorage('promotion_id', data.default_promotion_id);
      }
    } catch (err) {
      console.warn('initApp getAppConfig failed:', err);
    }
  }
}
